import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  AdvisorRepresentativeDetailsContainer,
  AdvisorRepresentativePlansContainer,
  ClearingPartnerContainer,
} from "../containers";
import {
  ClearingPartner,
  ClearingPartnerDetails,
  ClearingPartnerAccountPlans,
  Advisor,
} from "../layouts";

import { MANAGE_MASTERS_ROUTES, ApplicationRoute, ROUTES } from "../utils";

const menu = "mapper";
export const ManageMasterRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        path={[`${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER}`]}
        component={ClearingPartner}
        //component={MapAndTransformOutputContainer}
      />
      <ApplicationRoute
        exact
        path={[
          `${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS}/:clearingPartnerId?`,
        ]}
        component={ClearingPartnerDetails}
      />
      <ApplicationRoute
        exact
        path={[
          `${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER__ACCOUNT_PLAN_DETAILS}/:clearingPartnerId?/:clearingPartnerAccountId?`,
        ]}
        component={ClearingPartnerAccountPlans}
      />
      <ApplicationRoute
        exact
        path={[`${MANAGE_MASTERS_ROUTES.ADVISOR}`]}
        component={Advisor}
      />
      <ApplicationRoute
        exact
        path={[
          `${MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_DETAILS}/:advisorId?`,
        ]}
        component={AdvisorRepresentativeDetailsContainer}
      />
      <ApplicationRoute
        exact
        path={[
          `${MANAGE_MASTERS_ROUTES.ADVISOR_REPRESENTATIVE_PLAN_DETAILS}/:advisorId?/:advisorRepresentativeId?`,
        ]}
        component={AdvisorRepresentativePlansContainer}
      />
      <Redirect
        from={ROUTES.MASTERS}
        to={MANAGE_MASTERS_ROUTES.CLEARING_PARTNER}
      />
    </Switch>
  );
};
